var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fb-like",attrs:{"data-href":"https://facebook.com/joszaki","data-width":"","data-layout":"button_count","data-action":"like","data-size":"large","data-share":"false"}})
}
var staticRenderFns = []

export { render, staticRenderFns }